import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

const sdgResponded: string = 'sdgResponded';

export const MARK_HULL_AS_RESPONDED: EffectFunction = ({ slotHull }: Adslot) => {
    slotHull.classList.add(sdgResponded);
    return () => {
        slotHull?.classList.remove(sdgResponded);
    };
};
